package org.vreo.devicehub.features.vrmOutput.data.repository

import org.vreo.devicehub.features.core.domain.DataError
import org.vreo.devicehub.features.core.domain.EmptyResult
import org.vreo.devicehub.features.core.domain.Result
import org.vreo.devicehub.features.core.domain.device.device.networking.RemoteDeviceControl
import org.vreo.devicehub.features.core.domain.device.vrmConfig.VrmOutputConfig
import org.vreo.devicehub.features.vrmOutput.domain.VrmOutputRepository

/**
 * Vrm output repository default. Allows to configure VRM output on the target device using
 * Tensor backend services.
 *
 * @property deviceControl Provides access to device control methods
 */
class VrmOutputRepositoryDefault(
    val deviceControl: RemoteDeviceControl,
) : VrmOutputRepository {
    override suspend fun getConfiguration(
        token: String,
        deviceId: String
    ): Result<List<VrmOutputConfig>, DataError.Remote> {
        return deviceControl.getVrmConfiguration(token, deviceId)
    }

    override suspend fun setConfiguration(
        token: String,
        deviceId: String,
        config: List<VrmOutputConfig>
    ): EmptyResult<DataError.Remote> {
        return deviceControl.setVrmConfiguration(token = token, deviceId = deviceId, config = config)
    }
}